import React, { useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import RadiologistApi from "../../../services/ApiServices/RadiologistApi";
import axios from "axios";
import JSZip from "jszip";
import spinner from "../../../assets/spiner.svg";
import AlertConfirm from "../../../components/modals/Confirm";
import SystemMessage from "../../../components/customComp/SystemMessage";
import MainRouters from "../../MainRouters";

const PatientCaseListRow = ({ exam,openTabOnClick }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [systemError, setSystemError] = useState(null);
  const [systemErrorCount, setSystemErrorCount] = useState(0);

  const clearSystemError = () => {
    handleSystemError(null);
  };

  const handleSystemError = (message) => {
    setSystemErrorCount((prev) => prev + 1);
    setSystemError(message);
  };

  const radsScore = {
    0: { border: "", text: "Incomplete", textColor: "", bgColor: "" },
    1: {
      border: "border-[#FFF]",
      text: "Negative",
      textColor: "text-[#FFF]",
      bgColor: "bg-white/10",
    },
    2: {
      border: "border-radsGreen",
      text: "LungRADS 2",
      textColor: "text-[#34C759]",
      bgColor: "bg-radsGreen",
    },
    3: {
      border: "border-radsYellow",
      text: "LungRADS 3",
      textColor: "text-radsYellow",
      bgColor: "bg-customYellow",
    },
    4: {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    "4a": {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    "4b": {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    "4x": {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    S: { border: "", text: "LungRADS S", textColor: "", bgColor: "" },
  };

  const { examId, patientId, findingScore, createdAt, status } = exam || {};
  const adjustedFindingScore = findingScore > 4 ? 4 : findingScore;

  const handleOpenDICOMViewer = async () => {
    debugger

    try {
      if (status === "pending") {
        setSystemErrorCount((prev) => prev + 1);
        setSystemError(
          "The analysis process is still ongoing. Results will be available once the algorithm has finished processing."
        );

        return;
      }
      if (status === "failed") {
        setSystemErrorCount((prev) => prev + 1);
        setSystemError(
          "The analysis process Falied. Please try to upload the exam again or contact the Genesis team."
        );

        return;
      }

      setLoading(true);

      const { isNew, tab } = openTabOnClick(patientId, examId);

      if (isNew === false) {
        // Tab already open → just navigate to it, NO fetching
        navigate(
          `/Radiologist/Patient/${patientId}/CaseId/${examId}/DICOMViewer`,{ state: tab.dicomProps }
        );
        return;
      }

      const { dicomUrl, resultUrl } = await RadiologistApi.getResults(examId);
      if (!dicomUrl || !resultUrl)
        throw new Error("Missing DICOM or result URL");

      const s3Axios = axios.create();
      const zipBuf = await s3Axios.get(dicomUrl, {
        responseType: "arraybuffer",
      });

      const zip = await JSZip.loadAsync(zipBuf.data);
      const files = await Promise.all(
        Object.values(zip.files)
          .filter((f) => !f.dir)
          .map(async (f) => new File([await f.async("blob")], f.name))
      );

      if (files.length === 0) throw new Error("No DICOM files found in ZIP");

      const resultResp = await s3Axios.get(resultUrl);

      const dicomProps = {
        patientId,
        accessionNumber: examId,
        createdAt,
        dicomFiles: files,
        jsonData: resultResp.data,
      };
      openTabOnClick(patientId,examId,dicomProps);

    } catch (error) {
      console.error("Error checking file availability:", error);
      alert("Error checking file availability.");
    } finally {
      setLoading(false);
    }
  };

  function insertDash(inputString) {
    if (inputString?.length > 7) {
      return inputString.slice(0, 7) + "-" + inputString.slice(7);
    }
    return inputString;
  }

  return (
    <>
      <div
        onClick={handleOpenDICOMViewer}
        className="rounded-[8px] w-[99%] h-[59px] min-h-[59px] bg-[#2B2B2B] pl-[30px] shadow-PatientCaseListRow flex text-white items-center cursor-pointer">
        <div className="w-caseId">{insertDash(examId)}</div>
        <div className="w-risNumber">{insertDash(patientId)}</div>
        <div className="w-aquisitionDateHx">
          {dayjs(createdAt).format("DD.MM.YYYY")}
        </div>
        <div className="w-status flex items-center gap-2">
          <span
            className={`${
              status === "complete"
              ? "green-status-dot"
              : status === "failed"
              ? "red-status-dot"
              : "yellow-status-dot"
            }`}
          />
          {status === "complete"
              ? "Complete"
              : status === "failed"
              ? "Failed"
              : "Pending Analysis"}
        </div>

        <div className="w-findings">{findingScore}</div>
      </div>

      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center z-50">
          <img
            src={spinner}
            alt="Loading…"
            className="animate-spin h-16 w-16 filter invert"
          />
          <p className="mt-4 text-white text-lg font-medium">
            Loading viewer data…
          </p>
        </div>
      )}

      {systemError && (
        <SystemMessage
          type="warning"
          title="Error"
          key={`${systemError}${systemErrorCount}`}
          message={systemError}
          handleClose={clearSystemError}
        />
      )}
    </>
  );
};

export default PatientCaseListRow;
